import heroImage from "../../assets/illustration.svg";
import iconBulb from "../../assets/iconBulb.png";
import iconPuzzle from "../../assets/iconPuzzle.png";
import iconRocket from "../../assets/iconRocket.png";
import skilledIcon from "../../assets/skilledIcon.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="font-poppins bg-[#f8f9fb] px-4 md:px-8 lg:px-16 py-8 md:py-16 xl:py-20 overflow-hidden relative">
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        {/* LEFT TEXT SECTION */}
        <div className="w-full md:w-[60%] text-left mb-8 md:mb-0">
          <div className="mb-4 md:mb-6 xl-mb-10">
            <p className="text-[#07862B] text-[16px] md:text-[20px] font-medium mb-4 md:mb-5 xl:mb-8 leading-tight">
              Solutions for your business
            </p>
            <h1 className="text-[#212129] text-[24px] md:text-[32px] xl:text-[48px] font-medium leading-tight mb-4 md:mb-5 lg:mb-8 ">
              IT consulting with
              <br className="hidden md:block" />
              professionalism & integrity
            </h1>
            <div className="w-[15%] border border-[#07862B] mb-4 md:mb-5 xl:mb-8"></div>
            <p className="text-[#212129] text-sm md:text-[16px] leading-normal font-regular">
              We uphold professionalism in the IT industry by delivering
              top-quality consulting and related services.
            </p>
          </div>
          <div className="flex gap-4 justify-center lg:justify-start">
            <Link to="/Contact">
              <button className="bg-[#07862B] text-white px-6 py-3 xl:px-10 xl:py-4 rounded-md text-sm md:text-[16px] font-semibold">
                Get a Quote
              </button>
            </Link>

            <a
              href="https://www.lentera.in/why-us/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="border border-[#07862B] text-[#07862B] px-6 py-3 xl:px-10 xl:py-4 rounded-md text-sm md:text-[16px] font-semibold">
                Learn more
              </button>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE + FLOATING ICONS */}
        <div className="w-full md:w-[40%] relative max-w-[600px] mx-auto lg:mx-0">
          {/* Hero Image */}
          <img
            src={heroImage}
            alt="Team illustration"
            className="w-full h-auto relative z-10 object-contain"
          />

          {/* Floating Icons */}
          <motion.div
            initial={{ y: -8 }}
            animate={{ y: 0 }}
            transition={{
              repeat: Infinity,
              duration: 2,
              repeatType: "reverse",
            }}
            className="absolute  top-[-15%] right-[8.5%] md:top-[-20%] md:right-[3%] xl:top-[-15%] xl:right-[8.5%] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
          >
            <img src={iconBulb} alt="Bulb" className="w-5 lg:w-6 h-5 lg:h-6" />
          </motion.div>

          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            transition={{
              repeat: Infinity,
              duration: 2.3,
              repeatType: "reverse",
            }}
            className="absolute top-[-10%] right-[27%] md:right-[29%] md:top-[-12%] xl:top-[-10%] xl:right-[27%] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
          >
            <img
              src={iconPuzzle}
              alt="Puzzle"
              className="w-8 lg:w-10 h-8 lg:h-10"
            />
          </motion.div>

          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            transition={{
              repeat: Infinity,
              duration: 2.8,
              repeatType: "reverse",
            }}
            className="absolute top-[5%] right-[12%] top-[6%] md:right-[4%] xl:top-[5%] xl:right-[12%] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
          >
            <img
              src={iconRocket}
              alt="Rocket"
              className="w-6 lg:w-8 h-6 lg:h-8"
            />
          </motion.div>

          {/* Floating Badge */}
          <motion.div
            initial={{ x: -10 }}
            animate={{ x: 0 }}
            transition={{
              repeat: Infinity,
              duration: 3,
              repeatType: "reverse",
            }}
            className="absolute bottom-[20px] left-[30px] sm:bottom-[40px] sm:left-[-20px] md:left-[-10px] bg-white rounded-[30px] shadow-lg px-4 md:px-5 py-2 md:py-3 flex items-center gap-2 md:gap-3 z-20"
          >
            <img
              src={skilledIcon}
              alt="Skilled Icon"
              className="w-[24px] md:w-[28px] h-[24px] md:h-[28px]"
            />
            <div className="text-[#222] text-[12px] md:text-[14px] font-regular leading-tight">
              Skilled <br /> professionals
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
